/** 设备重置相关接口 */
import request from '@/utils/util.request';

/*
 *  (reset) 重置设备，页面加载
 */
export const reset_load_data = (data) => {
	return request({
		url: '/reset/loaddata',
		data,
	});
};

/*
 *  (reset) 发送验证码
 *  @param {string} phone: 手机号
 */
export const reset_send_code = (data) => {
	return request({
		url: '/reset/sendvcode',
		data,
	});
};

/*
 *  (reset) 重置
 *  @param {string} devicenum: 设备编号
 *  @param {string} vcode: 验证码
 */
export const reset_submit = (data) => {
	return request({
		url: '/reset/submit',
		data,
	});
};
